import { useRouter } from 'next/router';

import LoansImage from '@/assets/images/loans-signed-out.png';
import MobileCommingSoon from '@/components/dashboard/borrow-land/MobileCommingSoon';
import LoggedOutModal from '@/components/shared/logged-out-modal';
import useAuthenticate from '@/hooks/useAuthenticate';

const LoansLending = () => {
  const router = useRouter();
  const { isAuth } = useAuthenticate();
  if (isAuth) {
    router.push('/loans/active');
    return null;
  }

  return (
    <>
      <LoggedOutModal className='max-lg:hidden' image={LoansImage} text='Sign up to connect your wallet & Borrow.' />
      <MobileCommingSoon />
    </>
  );
};

LoansLending.signedInDesign = true;

export default LoansLending;
